import React, { useState, useEffect, useRef, useCallback } from "react";
import Header from "./Header";
import Footer from "./Footer";
import RomLibrary from "../utitl/RomLibrary";
import config from "../config";

const ListPage = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalDatas, setTotalDatas] = useState([]);
  const [searchDatas, setSearchDatas] = useState([]);
  const [currentPageDatas, setCurrentPageDatas] = useState([]);
  const [searchContent, setSearchContent] = useState(null);
  const searchInputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "copy";
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.items
      ? e.dataTransfer.items[0].getAsFile()
      : e.dataTransfer.files[0];

    RomLibrary.save(file).then((rom) => {
      props.history.push({ pathname: "run/local-" + rom.hash });
    });
  };

  const getParam = (name, url) => {
    if (!url) url = window.location.href;
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    let results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  };

  const showPage = useCallback(
    (currentPage, searchData = searchDatas, totalData = totalDatas) => {
      const first = (currentPage - 1) * pageSize + 1;
      const last = currentPage * pageSize;
      let currentPageData = [];

      const dataSource = searchData.length > 0 ? searchData : totalData;

      dataSource.forEach((item, i) => {
        if (i < first - 1 || i > last - 1) return;
        currentPageData.push(item);
      });

      setCurrentPageDatas(currentPageData);
    },
    [pageSize, searchDatas, totalDatas]
  );

  const navigationGamePageHandler = (e) => {
    const name = e.target.dataset.name;
    props.history.push("/run/" + encodeURIComponent(name));
  };

  const changePage = (e) => {
    const val = e.target.dataset.value;
    let newCurrentPage = 1;
    try {
      if (val === "-1") {
        newCurrentPage = currentPage === 1 ? 1 : currentPage - 1;
      } else if (val === "+1") {
        newCurrentPage =
          currentPage === totalPages ? totalPages : currentPage + 1;
      } else {
        newCurrentPage = Number(val);
      }
    } catch (e) {
      newCurrentPage = 1;
    }

    sessionStorage.setItem("currentPage", newCurrentPage);
    setCurrentPage(newCurrentPage);
    props.history.push({ search: "?page=" + newCurrentPage });
    showPage(newCurrentPage);
  };

  const onchangeHadler = (e) => {
    setSearchContent(e.target.value);
  };

  const onKeyDownHandler = (e) => {
    if (e.keyCode === 13) {
      searchHandler(e);
    }
  };

  const searchHandler = (e) => {
    const searchContentValue = searchInputRef.current.value;

    sessionStorage.setItem("searchContent", searchContentValue);
    const newSearchDatas = totalDatas.filter(
      (el) =>
        el.game_name
          ?.toLowerCase()
          .includes(searchContentValue.trim().toLowerCase()) ||
        el.description
          ?.toLowerCase()
          .includes(searchContentValue.trim().toLowerCase()) ||
        el.developer
          ?.toLowerCase()
          .includes(searchContentValue.trim().toLowerCase()) ||
        el.platform
          ?.toLowerCase()
          .includes(searchContentValue.trim().toLowerCase()) ||
        el.genre
          ?.toLowerCase()
          .includes(searchContentValue.trim().toLowerCase())
    );

    const first = 1;
    const last = pageSize;
    let newTotalPages = 1;
    let newCurrentPageDatas = [];

    if (newSearchDatas.length > 0) {
      newSearchDatas.forEach((item, i) => {
        if (i < first - 1 || i > last - 1) return;
        newCurrentPageDatas.push(item);
      });
      newTotalPages =
        Math.ceil(newSearchDatas.length / pageSize) < 1
          ? 1
          : Math.ceil(newSearchDatas.length / pageSize);
    } else if (!searchContentValue) {
      totalDatas.forEach((item, i) => {
        if (i < first - 1 || i > last - 1) return;
        newCurrentPageDatas.push(item);
      });
      newTotalPages =
        Math.ceil(totalDatas.length / pageSize) < 1
          ? 1
          : Math.ceil(totalDatas.length / pageSize);
    }

    sessionStorage.setItem("currentPage", "1");
    props.history.push({ search: "?page=1" });

    setSearchContent(searchContentValue);
    setSearchDatas(newSearchDatas);
    setTotalPages(newTotalPages);
    setCurrentPage(1);
    setCurrentPageDatas(newCurrentPageDatas);
  };

  useEffect(() => {
    // google analytics
    document.title = "Family Computer Games";
    window.gtag("config", process.env.REACT_APP_GOOGLE_ANALYTICS_ID, {
      page_path: props.location.pathname,
    });

    // 当前页面sessionStorage中存在使用存在的，不存为1
    let initialCurrentPage = sessionStorage.getItem("currentPage")
      ? Number(sessionStorage.getItem("currentPage"))
      : 1;

    // 所有的游戏数据的list
    const initialTotalDatas = [];
    Object.entries(config.ROMS).forEach((val, idx) => {
      initialTotalDatas.push({
        no: idx + 1,
        name: String(val[0]),
        game_name: String(val[0]).replaceAll("_", " "),
        description: val[1].description,
        developer: val[1].developer,
        platform: val[1].platform,
        genre: val[1].genre,
      });
    });

    // 检索内容存在的情况
    const initialSearchContent = sessionStorage.getItem("searchContent");
    let initialSearchDatas = [];
    if (initialSearchContent) {
      initialSearchDatas = initialTotalDatas.filter(
        (el) =>
          el.game_name
            ?.toLowerCase()
            .includes(initialSearchContent.trim().toLowerCase()) ||
          el.description
            ?.toLowerCase()
            .includes(initialSearchContent.trim().toLowerCase()) ||
          el.developer
            ?.toLowerCase()
            .includes(initialSearchContent.trim().toLowerCase()) ||
          el.platform
            ?.toLowerCase()
            .includes(initialSearchContent.trim().toLowerCase()) ||
          el.genre
            ?.toLowerCase()
            .includes(initialSearchContent.trim().toLowerCase())
      );
    }

    // 总的页数
    const initialTotalPages =
      initialSearchDatas.length > 0
        ? Math.ceil(initialSearchDatas.length / pageSize) < 1
          ? 1
          : Math.ceil(initialSearchDatas.length / pageSize)
        : Math.ceil(initialTotalDatas.length / pageSize) < 1
        ? 1
        : Math.ceil(initialTotalDatas.length / pageSize);

    // url parameter 覆盖sessionStorage
    const page = Number(getParam("page"));
    if (page) {
      if (isNaN(page) || page < 1) {
        initialCurrentPage = 1;
      } else if (page > initialTotalPages) {
        initialCurrentPage = initialTotalPages;
      } else {
        initialCurrentPage = page;
      }
    }
    props.history.push({ search: "?page=" + initialCurrentPage });

    // 当前页的第一个
    const first = (initialCurrentPage - 1) * pageSize + 1;
    // 当前页的最后一个
    const last = initialCurrentPage * pageSize;
    // 当前页的数据
    let initialCurrentPageDatas = [];

    // 检索到的数据如果不为空
    const dataSource =
      initialSearchDatas.length > 0 ? initialSearchDatas : initialTotalDatas;
    dataSource.forEach((item, i) => {
      if (i < first - 1 || i > last - 1) return;
      initialCurrentPageDatas.push(item);
    });

    setTotalDatas(initialTotalDatas);
    setSearchContent(initialSearchContent);
    setSearchDatas(initialSearchDatas);
    setCurrentPage(initialCurrentPage);
    setCurrentPageDatas(initialCurrentPageDatas);
    setTotalPages(initialTotalPages);
  }, [props.history, props.location.pathname, pageSize]);

  useEffect(() => {
    showPage(currentPage);
  }, [currentPage, searchDatas, totalDatas, showPage]);

  return (
    <>
      {/* Header */}
      <Header />
      <div
        className="drop-zone"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <section className="hero">
          <div className="hero-content">
            <h1>
              Game <span>Library</span>
            </h1>
            <p>
              Browse games. Find your next favorite adventure from hundreds of
              titles.
            </p>
            <div className="search-bar">
              <input
                ref={searchInputRef}
                type="text"
                placeholder="Search games..."
                value={searchContent ?? ""}
                onChange={onchangeHadler}
                onKeyDown={onKeyDownHandler}
              />
              <button onClick={searchHandler}>
                <i className="fas fa-search"></i>
              </button>
            </div>
          </div>
        </section>

        <section className="games-section">
          <div className="games-list">
            {currentPageDatas.map((el, idx) => {
              return (
                <div className="game-item" key={el.game_name} data-no={el.no}>
                  <div className="game-image">
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        background: "linear-gradient(45deg, #74b9ff, #0984e3)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                      }}
                    >
                      <i
                        className="fas fa-gamepad"
                        style={{ fontSize: "60px" }}
                      ></i>
                    </div>
                  </div>
                  <div className="game-content">
                    <h3 className="game-title" title={el.game_name}>
                      {el.game_name}
                    </h3>
                    <p className="game-description" title={el.description}>
                      {el.description}
                    </p>
                    <div
                      className="game-meta"
                      onClick={navigationGamePageHandler}
                    >
                      <div
                        className="game-play"
                        data-no={el.no}
                        data-name={el.name}
                        data-game-name={el.game_name}
                        data-description={el.description}
                        data-developer={el.developer}
                        data-platform={el.platform}
                        data-genre={el.genre}
                      >
                        Play Now
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="page-container">
            <button
              className="btn btn-primary"
              data-value="1"
              onClick={changePage}
            >
              &lt;&lt;
            </button>
            <button
              className="btn btn-primary"
              data-value="-1"
              onClick={changePage}
            >
              &lt;
            </button>
            <button
              className="btn btn-primary"
              data-value="+1"
              onClick={changePage}
            >
              &gt;
            </button>
            <button
              className="btn btn-primary"
              data-value={totalPages}
              onClick={changePage}
            >
              &gt;&gt;
            </button>
          </div>
          <div className="page">
            {currentPage} / {totalPages}
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default ListPage;
